import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
      },
    clientname: {
      validations: []
    },
    email: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
      },
    partyname: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
      },
    theme: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
      },
    sitename: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
       },
    plannedguestcount: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    starttime: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    endtime: {
      validations: []
       },
    eventExtra1: {
      validations: [
        { type: 'maxLength', maxLength: 50, message: 'Maximum number of  reached' },
        { type: 'required', message: 'Please fill in required field.' },
      ]
      },
    eventExtra2: {
      validations: [
        { type: 'maxLength', maxLength: 50, message: 'Maximum number of  reached' },
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    eventExtra3: {
      validations: [
        { type: 'maxLength', maxLength: 50, message: 'Maximum number of  reached' },
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    eventExtra4: {
      validations: [
        { type: 'maxLength', maxLength: 50, message: 'Maximum number of  reached' },
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Contact Us Regarding Your Event',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
       {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'We welcome the opportunity to learn more about your event and how we can serve you, so please fill out the form below and we will get back to you promptly.',
            mapping: 'headerLabel',
            customClasses: ['header1']
          }
        ]
      },

      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstName'
         }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'lastName'
          }
        ]
      },
       {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Company:',
            mapping: 'clientname'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone:*',
            mapping: 'telNumber'
           },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Event Name:*',
            mapping: 'partyname'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Event Type:*',
            options: [
              { label: 'Awards or Recognition'  , value: 'Awards or Recognition'},
              { label: 'Class or Course'  , value: 'Class or Course'},
              { label: 'Competition or Tournament'  , value: 'Competition or Tournament'},
              { label: 'Concert'  , value: 'Concert'},
              { label: 'Conference'  , value: 'Conference'},
              { label: 'Convention'  , value: 'Convention'},
              { label: 'Corporate'  , value: 'Corporate'},
              { label: 'Dinner/Gala'  , value: 'Dinner/Gala'},
              { label: 'Exhibition or Tradeshow'  , value: 'Exhibition or Tradeshow'},
              { label: 'Faith-Based'  , value: 'Faith-Based'},
              { label: 'Festival'  , value: 'Festival'},
              { label: 'Fundraiser'  , value: 'Fundraiser'},
              { label: 'Holiday Party'  , value: 'Holiday Party'},
              { label: 'Luncheon'  , value: 'Luncheon'},
              { label: 'Meeting'  , value: 'Meeting'},
              { label: 'Networking'  , value: 'Networking'},
              { label: 'Other'  , value: 'Other'},
              { label: 'Party or Celebration'  , value: 'Party or Celebration'},
              { label: 'Promotional (Launch or Signing)'  , value: 'Promotional (Launch or Signing)'},
              { label: 'Retreat or Trip'  , value: 'Retreat or Trip'},
              { label: 'Seminar or Workshop'  , value: 'Seminar or Workshop'},
              { label: 'Tasting'  , value: 'Tasting'},
              { label: 'Tour'  , value: 'Tour'},
              { label: 'Wedding'  , value: 'Wedding'},
            ],
            mapping: 'theme'
         }
        ]
      },
      {
        fields: [
          {
          type: 'text',
          size: 'Medium',
          label: 'Event Location: Name, Address and Zip Code (Must be within 40 miles of Chicago):*',
          mapping: 'sitename'
        },
        ]
      },
      {
        fields: [
          {
          type: 'text',
          size: 'Medium',
          label: 'Estimated Headcount:*',
          mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
          {
          type: 'date-picker',
          size: 'Medium',
          label: 'Preferred Event Date:*',
          mapping: 'eventDate'
          }
        ]
      },
      {
        fields: [
          {
        type: 'multiple-choice',
        size: 'Medium',
        label: 'Preferred Start Time:*',
        options: [
          { label: '6:00 AM'  , value: '06:00:00'},
          { label: '6:30 AM'  , value: '06:30:00'},
          { label: '7:00 AM'  , value: '07:00:00'},
          { label: '7:30 AM'  , value: '07:30:00'},
          { label: '8:00 AM'  , value: '08:00:00'},
          { label: '8:30 AM'  , value: '08:30:00'},
          { label: '9:00 AM'  , value: '09:00:00'},
          { label: '9:30 AM'  , value: '09:30:00'},
          { label: '10:00 AM' , value: '10:00:00'},
          { label: '10:30 AM' , value: '10:30:00'},
          { label: '11:00 AM' , value: '11:00:00'},
          { label: '11:30 AM' , value: '11:30:00'},
          { label: '12:00 PM' , value: '12:00:00'},
          { label: '12:30 PM' , value: '12:30:00'},
          { label: '1:00 PM'  , value: '13:00:00'},
          { label: '1:30 PM'  , value: '13:30:00'},
          { label: '2:00 PM'  , value: '14:00:00'},
          { label: '2:30 PM'  , value: '14:30:00'},
          { label: '3:00 PM'  , value: '15:00:00'},
          { label: '3:30 PM'  , value: '15:30:00'},
          { label: '4:00 PM'  , value: '16:00:00'},
          { label: '4:30 PM'  , value: '16:30:00'},
          { label: '5:00 PM'  , value: '17:00:00'},
          { label: '5:30 PM'  , value: '17:30:00'},
          { label: '6:00 PM'  , value: '18:00:00'},
          { label: '6:30 PM'  , value: '18:30:00'},
          { label: '7:00 PM'  , value: '19:00:00'},
          { label: '7:30 PM'  , value: '19:30:00'},
          { label: '8:00 PM'  , value: '20:00:00'},
          { label: '8:30 PM'  , value: '20:30:00'},
          { label: '9:00 PM'  , value: '21:00:00'},
          { label: '9:30 PM'  , value: '21:30:00'},
          { label: '10:00 PM' , value: '22:00:00'},
          { label: '10:30 PM' , value: '22:30:00'},
          { label: '11:00 PM', value: '23:00:00' },
          { label: '11:30 PM', value: '23:30:00' },
          { label: '12:00 AM', value: '00:00:00' },
          { label: '12:30 AM', value: '00:30:00' },
          { label: '1:00 AM', value: '01:00:00' },
          { label: '1:30 AM', value: '01:30:00' },
          { label: '2:00 AM', value: '02:00:00' },
        ],
        mapping: 'starttime'
     }
        ]
      },
      {
        fields: [
          {
        type: 'multiple-choice',
        size: 'Medium',
        label: 'Preferred End Time:',
        options: [
          { label: '6:00 AM'  , value: '06:00:00'},
          { label: '6:30 AM'  , value: '06:30:00'},
          { label: '7:00 AM'  , value: '07:00:00'},
          { label: '7:30 AM'  , value: '07:30:00'},
          { label: '8:00 AM'  , value: '08:00:00'},
          { label: '8:30 AM'  , value: '08:30:00'},
          { label: '9:00 AM'  , value: '09:00:00'},
          { label: '9:30 AM'  , value: '09:30:00'},
          { label: '10:00 AM' , value: '10:00:00'},
          { label: '10:30 AM' , value: '10:30:00'},
          { label: '11:00 AM' , value: '11:00:00'},
          { label: '11:30 AM' , value: '11:30:00'},
          { label: '12:00 PM' , value: '12:00:00'},
          { label: '12:30 PM' , value: '12:30:00'},
          { label: '1:00 PM'  , value: '13:00:00'},
          { label: '1:30 PM'  , value: '13:30:00'},
          { label: '2:00 PM'  , value: '14:00:00'},
          { label: '2:30 PM'  , value: '14:30:00'},
          { label: '3:00 PM'  , value: '15:00:00'},
          { label: '3:30 PM'  , value: '15:30:00'},
          { label: '4:00 PM'  , value: '16:00:00'},
          { label: '4:30 PM'  , value: '16:30:00'},
          { label: '5:00 PM'  , value: '17:00:00'},
          { label: '5:30 PM'  , value: '17:30:00'},
          { label: '6:00 PM'  , value: '18:00:00'},
          { label: '6:30 PM'  , value: '18:30:00'},
          { label: '7:00 PM'  , value: '19:00:00'},
          { label: '7:30 PM'  , value: '19:30:00'},
          { label: '8:00 PM'  , value: '20:00:00'},
          { label: '8:30 PM'  , value: '20:30:00'},
          { label: '9:00 PM'  , value: '21:00:00'},
          { label: '9:30 PM'  , value: '21:30:00'},
          { label: '10:00 PM' , value: '22:00:00'},
          { label: '10:30 PM' , value: '22:30:00'},
          { label: '11:00 PM', value: '23:00:00' },
          { label: '11:30 PM', value: '23:30:00' },
          { label: '12:00 AM', value: '00:00:00' },
          { label: '12:30 AM', value: '00:30:00' },
          { label: '1:00 AM', value: '01:00:00' },
          { label: '1:30 AM', value: '01:30:00' },
          { label: '2:00 AM', value: '02:00:00' },
        ],
        mapping: 'endtime'
        }
        ]
      },
       {
        fields: [
          {
            type: 'radio-buttons',
            size: 'Medium',
            label: 'What is your budget for this event?:*',
            options: [
          { label: 'Less than $2K'  , value: 'Less than $2K'},
          { label: '$2K-$4K'  , value: '$2K-$4K'},
          { label: '$4K - $5K'  , value: '$4K - $5K'},
          { label: 'More than $5K'  , value: 'More than $5K'},
            ],
            mapping: 'eventExtra1'
           }
        ]
      },
      {
        fields: [
          {
            type: 'checkbox-list',
            size: 'Medium',
            label: 'Please let us know what type(s) of beverages/bar service you\'re interested in having at your event?:*',
            options: [
          { label: 'Beer'  , value: 'Beer'},
          { label: 'Wine'  , value: 'Wine'},
          { label: 'Spirits (Cocktails)'  , value: 'Spirits (Cocktails)'},
          { label: 'Non-Alcoholic Options (Mocktails)'  , value: 'Non-Alcoholic Options (Mocktails)'},
          { label: 'Signature Cocktails'  , value: 'Signature Cocktails'},
          { label: 'Soft Drinks, Mixers and Bartenders'  , value: 'Soft Drinks, Mixers and Bartenders'},
            ],
            mapping: 'eventExtra2'
           }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Our Bar Packages include disposable for the bar beverages. Would you like to upgrade to glassware for the bar beverages?:*',
             options: [
              { label: 'Yes', value: 'Yes'},
              { label: 'No', value: 'No'},
              { label: 'I\'m not sure yet', value: 'I\'m not sure yet'},
            ],
            mapping: 'eventExtra3'
         }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Does your venue have a physical bar from which our bartenders will serve?:*',
             options: [
              { label: 'Yes, the venue has a physical bar' , value: 'Yes, the venue has a physical bar'},
              { label: 'No, please add a Portable Bar to our quote' , value: 'No, please add a Portable Bar to our quote'},
            ],
            mapping: 'eventExtra4'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'XLarge',
            label: 'Please give us details about your event and service request: Timeline, event flow, will there be any programming (speeches, performances, etc.), what do you think the most popular beverage will be during this event, etc?:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SUBMIT'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Drinks On Me Chicago Contact Form',
    formId: '2215',
    clientKey: 'DC7B53C5-CBEC-49F1-8212-A6973D601BD8',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your inquiry has been successfully sent. We will contact you in 24 business hours.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
